// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3het0","author":"Table_author__3090-","authorImage":"Table_authorImage__1a3SW","unreadRow":"Table_unreadRow__3rx43"};